  import axios from "axios";
  import { BASE_URL } from "../../variables";

  export const DRMPlanOneAPI = async ({ method = "post", newFormData, meetingId }) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    const options = {
      method,
      headers,
    };

    if (method === "post") {
      console.log("Inside POST ===>");
      options.url = `${BASE_URL}/services/apexrest/Add_DRM_Plan`;
      options.data = { DRM: [newFormData] };
    }

    if (method === "get") {
      console.log("Inside GET ===>");
      options.url = `${BASE_URL}/services/apexrest/Add_DRM_Plan?Id=${meetingId}`;
    }

    try {
      const response = await axios(options);
      console.log("Response Data get==>", response  )
      return { success: true, data: response?.data };
    } catch (err) {
      return { success: false, msg: "Something Went Wrong", err };
    }
  };